import { AuthProvider } from '@/shared/auth';
import { QueryProvider } from '@/shared/query';
import { ModalProvider, Toaster, TooltipProvider } from '@/shared/ui';
import { LanguageProvider, ThemeProvider } from '@app/providers';
import { AppRouter } from '@app/routers';

import { componentDictionary, useInitMoment } from './configs';

import 'flag-icons/css/flag-icons.min.css';

export const Root = () => {
  useInitMoment();

  return (
    <LanguageProvider>
      <ThemeProvider>
        <TooltipProvider>
          <ModalProvider components={componentDictionary}>
            <QueryProvider>
              <AuthProvider>
                <AppRouter />
              </AuthProvider>
            </QueryProvider>
            <Toaster />
          </ModalProvider>
        </TooltipProvider>
      </ThemeProvider>
    </LanguageProvider>
  );
};
